import * as loginTypes from "./actionTypes";

export const setCountry = (country) => {
  return {
    type: loginTypes.SET_COUNTRY,
    payload: country,
  };
};
export const setAgentId = (agent) => {
  return {
    type: loginTypes.SET_AGENT_ID,
    payload: agent,
  };
};
export const setMail = (mail) => {
  return {
    type: loginTypes.SET_EMAIL,
    payload: mail,
  };
};
export const getCords = () => {
  window.navigator.geolocation.watchPosition((poss) => {
    const cords = {
      latitude: poss.coords.latitude,
      longitude: poss.coords.latitude,
    };
    return {
      type: loginTypes.GET_CORDS,
      payload: cords,
    };
  });
};
export const getUserData = () => {
  return {
    type: loginTypes.GET_USER_DATA,
  };
};

export const setUserData = (userData) => {
  return {
    type: loginTypes.SET_USER_DATA,
    payload: userData,
  };
};
export const setCommerceData = (commerceData) => {
  return {
    type: loginTypes.SET_COMMERCE_DATA,
    payload: commerceData,
  };
};
export const setCommerce = (isCommerce) => {
  return {
    type: loginTypes.SET_LEGAL_ENTITY,
    payload: isCommerce,
  };
};
export const setStatus = (status) => {
  return {
    type: loginTypes.SET_STATUS,
    payload: status,
  };
};
export const destroyAllData = () => {
  return {
    type: loginTypes.DESTROY_ALL_DATA,
  };
};

export const setToken = (token) => {
  return {
    type: loginTypes.SET_TOKEN,
    payload: token,
  };
};
export const setDocTypeAndQuantity = ({ docTypes, quantity }) => {
  return {
    type: loginTypes.SET_DOC_TYPE_QUANTITY,
    payload: { docTypes, quantity },
  };
};
export const setUserDocFiles = (userFiles) => {
  return {
    type: loginTypes.SET_DOC_FILES,
    payload: userFiles,
  };
};
export const isMerchantProfile = (isMerchantProfile) => {
  return {
    type: loginTypes.IS_MERCHANT_PROFILE,
    payload: isMerchantProfile,
  };
};
export const setInitialOnboardingState = () => {
  return {
    type: loginTypes.SET_INITIAL_ONBOARDING_STATE,
  };
};
